import React from 'react';
import { Navbar, Nav } from 'react-bootstrap'
import moment from 'moment'
import AppVersion from '../../versioning/app-label'
import ApiVersion from '../../versioning/api-label'

function Footer ({ name, onLogout }) {
    return (
        <footer>
            <Navbar bg='light' variant='light' fixed="bottom">
                <Nav className='m-left'><Nav.Item className='text-muted' style={{ fontSize: '0.8em'}}><AppVersion /></Nav.Item></Nav>
                <Nav className='m-auto'><Nav.Item className='text-muted'>&copy; Divine Savior Holy Angels {moment().format('YYYY')}</Nav.Item></Nav>
                <Nav className='m-right'><Nav.Item className='text-muted' style={{ fontSize: '0.8em'}}><ApiVersion /></Nav.Item></Nav>
            </Navbar>
        </footer>
    )
}

export default Footer
